/*--------------------------------------
        SLIDER HEADQUARTERS
 --------------------------------------*/
SliderHeadquarters = {
  init: function () {
    new Swiper('.swiper__addresses', {
      loop: true,
      slidesPerView: 1,
      spaceBetween: 0,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      breakpoints: {
        769: {
          slidesPerView: 2,
          grabCursor: false,
          allowTouchMove: false,
          spaceBetween: 30,
        }
      }
    });
  }
};



/*----------------------
 MENU GOT TO
 ----------------------*/

 if (window.location.href.indexOf("#") > -1) {
  var url = document.location.hash;
  console.log(url);
  setTimeout(function () {
    $('html, body').animate({
      scrollTop: parseInt($(url).offset().top - 128)
  }, 0);
}, 300);

}



$(function () {
  SliderHeadquarters.init();
});